export default __webpack_public_path__ + "static/media/filter_agenda_active.98856aba.svg";